import { useMutation, useQueryClient } from "react-query";
import { createPatient } from "@/services/patient";
/** Mutation hook for registering a new patient in a workspace; refreshes the worklist on success. */
export function useCreatePatient(sourceId) {
  var queryClient = useQueryClient();
  return useMutation(function (payload) {
    return createPatient(sourceId, payload);
  }, {
    onSuccess: function onSuccess() {
      void queryClient.invalidateQueries(["patients-v2"]);
      void queryClient.invalidateQueries(["patients-v2-count"]);
    }
  });
}